import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { AppBar, Stack, IconButton, Box, Typography, Backdrop, CircularProgress } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import axiosBaseURL from "../../../utilities/httpCommon";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";

//import process = require("process");

/* global console window caches */

//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

const TopAppBar = () => {
  const [title, setTitle] = React.useState("");
  const [isprogress, setisprogress] = React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const [errMsgd, seterrMsgd] = React.useState("");

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const calllogout = async () => {
    setisprogress(true);
    history.push("");
    await axiosBaseURL
      .get("/sfserver/auth/logout", {
        withCredentials: true,
      })
      .catch((error) => {
        setisprogress(false);
        if (error.response) {
          seterrMsgd(error.response.data);
        } else if (error.request) {
          seterrMsgd(error.request);
        } else {
          seterrMsgd(error.message);
        }
      })
      .then(() => {
        setisprogress(false);
        console.log("Logout sucessfully");
        //setState({ authStatus: "notLoggedIn" });
        //approps.LoggedIn = false;
        console.log(window.location.href);
        //localStorage.removeItem("tokenvalue");
        window.location.href = window.location.href + "taskpane.html";
        //window.location.reload();
      })
      .catch((error) => {
        setisprogress(false);
        console.log("Error");
        console.log(error);
      });
    console.log("caches.keys.length");
    console.log(caches.keys.length);
  };

  useEffect(() => {
    setTitle("Accordor");
    if (location.pathname == "/Insertfield") {
      setTitle("Insert fields");
    } else if (location.pathname == "/Markcondition") {
      setTitle("Define field condition");
    } else if (location.pathname == "/Markclause") {
      setTitle("Define clause condition");
    } else if (location.pathname == "/Marktable") {
      setTitle("Define table condition");
    } else if (location.pathname == "/Newtemplate") {
      setTitle("Create template");
    } else if (location.pathname == "/Controlpanel") {
      setTitle("Control manager");
    } else if (location.pathname == "/CheckIn") {
      setTitle("Check In template");
    } else if (location.pathname == "/Inserttable") {
      setTitle("Insert table");
    } else if (location.pathname == "/Checkout") {
      setTitle("Check out");
    } else if (location.pathname == "/chatgptai") {
      setTitle("AI Assistant");
    } else if (location.pathname == "/Playbook") {
      setTitle("Playbook");
    }
  }, [location]);
  return (
    <AppBar position="fixed" sx={{ height: 36, bgcolor: "#1C39BB" }}>
      {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        {title != "" && title == "Accordor" && (
          <Box
            sx={{
              paddingLeft: 0.5,
              margin: 0,
              height: 36,
              width: "auto",
              bgcolor: "transparent",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <img alt="Accordor" height={22} src="../components/../../../assets/logo-white.png"></img>
          </Box>
        )}
        {title != "" && title != "Accordor" && (
          <IconButton aria-label="delete" size="small" sx={{ color: "white" }} onClick={() => history.push("")}>
            <KeyboardBackspaceIcon fontSize="small" />
          </IconButton>
        )}
        {title != "" && title != "Accordor" && (
          <Typography variant="subtitle1" sx={{ color: "white", paddingTop: 0.5 }}>
            {title}
          </Typography>
        )}
        <IconButton
          onClick={calllogout}
          edge="end"
          color="inherit"
          sx={{
            justifyContent: "right",
            paddingRight: 2,
          }}
        >
          <LogoutRoundedIcon />
        </IconButton>
      </Stack>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isprogress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </AppBar>
  );
};

export default TopAppBar;
